import React from "react";
import Header from "../components/header/Header";
import Main from "../components/main/Main";
import TopPicks from "../components/top-picks/TopPicks";
import DownloadApplication from "../components/download-application/DownloadApplication";

const Home = () => {
  return (
    <>
      <Header />
      <Main />
      <TopPicks />
      <DownloadApplication />
    </>
  );
};

export default Home;
